import { DataSet } from '@models/index';

export class LineGraphData {
    labels: string[] = [];
    datasets: DataSet[] = [];
    options?: any;
}
